// Anuglar libraries
import { BrowserModule, Title, DomSanitizer } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// External plugins
import { SocialLoginModule } from 'angular-6-social-login';
import { GoogleLoginProvider, FacebookLoginProvider  } from 'angular-6-social-login';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
// import { CKEditorModule } from 'ckeditor4-angular';

import { QuillModule } from 'ngx-quill';
import { Daterangepicker } from 'ng2-daterangepicker';
// import { DragulaModule } from 'ng2-dragula';
import { EmbedVideo } from 'ngx-embed-video';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { NgSelectModule } from '@ng-select/ng-select';
// import { ContenteditableDirective } from 'ng-contenteditable';
// import { CKEditorModule } from 'ng2-ckeditor';

// Custom
import { AppRoutingModule } from './app-routing.module';
import { Config } from './config/config';

// Components
import { AppComponent } from './app.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { LoginComponent } from './component/login/login.component';
import { HeaderComponent } from './component/header/header.component';
// import { ListingComponent } from './component/listing/listing.component';

// Service, Guards and interceptors
import { AuthenticationService } from './service/authentication.service';
import { AuthGuard } from './service/auth.guard';
import { UserAuthGuard } from './service/userauth.guard';
import { CanDeactivateGuard } from './service/save-change.guard';
import { VideoDeactivateGuard } from './service/video-deactivate.guard'
import { WireComponent } from './component/wire/wire.component';
import { LeftMenuComponent } from './component/left-menu/left-menu.component';
// import { WorkspaceComponent } from './component/workspace/workspace.component';
import { RestDataService } from './service/rest-data.service';
import { CkedComponent } from './component/cked/cked.component';
// import { FilterComponent } from './component/filter/filter.component';
import { SharedDataService } from './service/shared-data.service';
import { WireStoryPreviewComponent } from './component/wire-story-preview/wire-story-preview.component';
import { JwtInterceptor } from './service/http_request.interceptor';
import { ErrorsHandler } from './error/error-handler';
import { HttpCacheService } from './service/cache.service';
import { StoryContainerComponent } from './component/story-container/story-container.component';
// import { TagsCreatorComponent } from './component/tags-creator/tags-creator.component';

import { KeyboardShortcuts } from './keyboard-shortcuts/keyboard-shortcuts';
// import { FilterPipe} from './component/filter/filter.pipe';
// import { PhotoListingComponent } from './component/photo-listing/photo-listing.component';
import { ElementModuleComponent } from './component/element-module/element-module.component';
import { TempViewCardComponent } from './component/temp-view-card/temp-view-card.component';
import { PageComponent } from './component/page/page.component';
import { CreatePageComponent } from './component/create-page/create-page.component';
import { PageContainerComponent } from './component/page-container/page-container.component';
import { PageListingComponent } from './component/page-listing/page-listing.component';
import { CollectionComponent } from './component/collection/collection.component';
import { NavManagerComponent } from './component/nav-manager/nav-manager.component';
import { ElementsComponent } from './component/elements/elements.component';
import { RelatedStoryViewComponent } from './component/related-story-view/related-story-view.component';
import { RelatedStoryListingComponent } from './component/related-story-listing/related-story-listing.component';
import { NavListingComponent } from './component/nav-listing/nav-listing.component';

import { ActuatorComponent } from './component/actuator/actuator.component';
import { NavPageComponent } from './component/nav-page/nav-page.component';
import { IframeTrackerDirective } from './service/iframe-tracker.directive';
import { TranslateService } from './service/translate.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TemplateComponent } from './component/template/template.component';
import { ZoneViewComponent } from './component/zone-view/zone-view.component';
import { ZoneListingComponent } from './component/zone-listing/zone-listing.component';
import { VideosComponent } from './component/videos/videos.component';
import { DeferLoadDirective } from './service/defer-load.directive';
import { FooterManagerComponent } from './component/nav-manager/footer-manager/footer-manager.component';
import { PageFooterComponent } from './component/nav-page/page-footer/page-footer.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { NuberInputDirective } from './directive/nuber-input.directive';
// import { ImageCropperComponent } from './component/image-cropper/image-cropper.component';
import { NewMetadataComponent } from './component/new-metadata/new-metadata.component';
// import { AuthorListingComponent } from './component/author-listing/author-listing.component';
// import { AuthorFormComponent } from './component/author-form/author-form.component';
import { MatchComponentComponent } from './component/match-component/match-component.component';
import { ElementListingComponent } from './component/element-listing/element-listing.component';
import { TwoDigitDecimaNumberDirective } from './directive/two-digit-decima-number.directive.directive';
import { BreakingNewsListingComponent } from './component/breaking-news-listing/breaking-news-listing.component';
// import { TextFilterPipe } from './service/textFilter.pipe';
import { SubNavComponent } from './component/nav-page/sub-nav/sub-nav.component';
import { SubNavManagerComponent } from './component/nav-manager/sub-nav-manager/sub-nav-manager.component';
import { SecondarySectionComponent } from './component/secondary-section/secondary-section.component';
import { SecondarySectionFormComponent } from './component/secondary-section-form/secondary-section-form.component';
import { SecondaryBrandComponent } from './component/secondary-brand/secondary-brand.component';
// import { AllStoryListingComponent } from './component/all-story-listing/all-story-listing.component';
import { AllElementListingComponent } from './component/all-element-listing/all-element-listing.component';
import { AllPageListingComponent } from './component/all-page-listing/all-page-listing.component';
import { AllVideoServiceListingComponent } from './component/all-video-service-listing/all-video-service-listing.component';
import { AllWireFeedListingComponent } from './component/all-wire-feed-listing/all-wire-feed-listing.component';
import { PageTypeListingComponent } from './component/page-type-listing/page-type-listing.component';
import { ExternalPageComponent } from './component/external-page/external-page.component';
import { ChartListingComponent } from './component/chart-listing/chart-listing.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ImagesListingComponent } from './component/images-listing/images-listing.component';
import { CommonUtilityService } from './service/common-utility.service';
import { SecondaryBrandFormComponent } from './component/secondary-brand-form copy/secondary-brand-form.component';
import { LocalstorageService } from './service/localstorage.service';
import { AffiliateListingComponent } from './component/affiliate-listing/affiliate-listing/affiliate-listing.component';
import { StoryContainerService } from './component/story-container/story-container.service';
import { WebStoriesComponent } from './component/web-stories/web-stories.component';
import { ColorPickerModule } from 'ngx-color-picker';

import { StoryVersionComponent } from './component/story-version/story-version.component';
import { PodcastListingComponent } from './component/podcast-listing/podcast-listing.component';
import { GoogleAnalyticsService } from './service/google-analytics.service';
import { CtrlClickDirective } from './service/ctrl-click.directive';
import { SpeechService } from './service/speech.service';
import { NoSanitizePipe } from './service/noSanitizePipe.pipe';
import { ReportingModuleComponent } from './component/reporting-module/reporting-module.component';
import { ReportListingComponent } from './component/report-listing/report-listing.component';
import { StoryTypeListingComponent } from './component/story-type-listing/story-type-listing.component';
import { SharedModule } from './shared-module/shared.module';
import { YoutubeVideosComponent } from './component/youtube-videos/youtube-videos.component';
import { YoutubeListingComponent } from './component/youtube-listing/youtube-listing.component';
import { TranslatedWireComponent } from './component/translated-wire/translated-wire.component';
import { HasRoleGuard } from './service/has-role.guard';
import { LiteDashboardComponent } from './component/lite/lite-dashboard/lite-dashboard.component';
import { LiteLeftMenuComponent } from './component/lite/lite-dashboard/component/lite/lite-left-menu/lite-left-menu.component';
import { LiteHeaderComponent } from './component/lite/lite-dashboard/component/lite/lite-header/lite-header.component';
import { LiteWorkspaceComponent } from './component/lite/lite-workspace/lite-workspace.component';
import { LiteAllStoryListingComponent } from './component/lite/lite-all-story-listing/lite-all-story-listing.component';
import { LiteStoryContainerComponent } from './component/lite/lite-story-container/lite-story-container.component';
import { AnalyticsDashboardComponent } from './component/analytics-dashboard/analytics-dashboard.component';
import { CustomPipe } from './component/custom.pipe';
import { AnalyticsRoleGuard } from './service/analytics-role.guard';
import { PhotoGalleryComponent } from './component/photo-gallery/photo-gallery.component';
import { AuthServiceConfig } from 'angular-6-social-login';
import { VideoCmsComponent } from './component/video-cms/video-cms.component';
import { VideoCmslistingComponent } from './component/video-cmslisting/video-cmslisting.component';
import { AllVideoCmsListingComponent } from './component/all-video-cms-listing/all-video-cms-listing.component';
import { MicrositeComponent } from './component/microsite/microsite.component';
import { MicrositeListingComponent } from './component/microsite-listing/microsite-listing.component';
import { MicrositeContainerComponent } from './component/microsite-container/microsite-container.component';
import { NotificationCenterPageComponent } from './notification-center-page/notification-center-page.component';
import { TextareaAutoresizeDirective } from './directive/textarea-autoresize.directive';
import { PageInlineComponent } from './component/page-inline-container/page-inline/page-inline.component';
import { OgImageComponent } from './component/og-image/og-image/og-image.component';
import { BrunchPreviewComponent } from './component/brunch-preview/brunch-preview.component';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { getSaver, SAVER } from './component/all-video-cms-listing/saver.provider';
import {MatProgressBarModule} from '@angular/material/progress-bar'; 
import {MatCardModule} from '@angular/material/card'; 
import {MatButtonModule} from '@angular/material/button'; 
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from './service/messaging.service';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { BrunchElementComponent } from './component/brunch-preview/brunch-element/brunch-element.component';
import { NewSecondarySectionComponent } from './component/new-secondary-section/new-secondary-section.component';
import { NewSecondarySectionFormComponent } from './component/new-secondary-section-form/new-secondary-section-form.component'; 
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SaranyuVideoListComponent } from './component/saranyu-video-list/saranyu-video-list.component';

const firebase = {
  apiKey: "AIzaSyBumzsxvlvggiyx7JRGJnP_8k37C8vK4OU",
  authDomain: "blankpaper-notifications.firebaseapp.com",
  projectId: "blankpaper-notifications",
  storageBucket: "blankpaper-notifications.appspot.com",
  messagingSenderId: "712653993784",
  appId: "1:712653993784:web:fc0101f8426a6b8c36f3cd",
  measurementId: "G-2E0GNSZ2Z6"
}

const login_config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider('59036276639-9ufea2catbasbmb6mmjn7kdsgpma6edn.apps.googleusercontent.com')
  },
  // {
  //   id: FacebookLoginProvider.PROVIDER_ID,
  //   provider: new FacebookLoginProvider('561602290896109')
  // },
  // {
  //   id: LinkedInLoginProvider.PROVIDER_ID,
  //   provider: new LinkedInLoginProvider("78iqy5cu2e1fgr")
  // }
]);

export function provideConfig() {
  return login_config;
}


const configFilePath = '';

export function configProviderFactory(provider: Config) {
  return () => provider.load(configFilePath);
}


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    // HeaderComponent,
    // ListingComponent,
    // WireComponent,
    // LeftMenuComponent,
    // WorkspaceComponent,
    CkedComponent,
    // FilterComponent,
    WireStoryPreviewComponent,
    StoryContainerComponent,
    //TagsCreatorComponent,
    // FilterPipe,
    // PhotoListingComponent,
    ElementModuleComponent,
    TempViewCardComponent,
    PageComponent,
    CreatePageComponent,
    PageContainerComponent,
    PageListingComponent,
    CollectionComponent,
    NavManagerComponent,
    ElementsComponent,
    RelatedStoryViewComponent,
    RelatedStoryListingComponent,
    AffiliateListingComponent,
    NavListingComponent,
    ActuatorComponent,
    NavPageComponent,
    IframeTrackerDirective,
    TemplateComponent,
    ZoneViewComponent,
    ZoneListingComponent,
    // VideosComponent,
    IframeTrackerDirective,
    DeferLoadDirective,
    FooterManagerComponent,
    PageFooterComponent,
    NuberInputDirective,
    // ImageCropperComponent,
    NewMetadataComponent,
    // AuthorListingComponent,
    // AuthorFormComponent,
    MatchComponentComponent,
    ElementListingComponent,
    TwoDigitDecimaNumberDirective,
    // BreakingNewsListingComponent,
    //TextFilterPipe,
    // NoSanitizePipe,
    SubNavComponent,
    SubNavManagerComponent,
    SecondarySectionComponent,
    SecondarySectionFormComponent,
    SecondaryBrandComponent,
    SecondaryBrandFormComponent,
    // AllStoryListingComponent,
    AllElementListingComponent,
    AllPageListingComponent,
    // AllVideoServiceListingComponent,
    // AllWireFeedListingComponent,
    PageTypeListingComponent,
    ExternalPageComponent,
    ChartListingComponent,
    // ImagesListingComponent,
    AffiliateListingComponent,
    WebStoriesComponent,
    StoryVersionComponent,
    PodcastListingComponent,
    CtrlClickDirective,
    // ReportingModuleComponent,
    // ReportListingComponent,
    StoryTypeListingComponent,
    // YoutubeVideosComponent,
    YoutubeListingComponent,
    // YoutubeVideosComponent,
    TranslatedWireComponent,
    LiteDashboardComponent,
    LiteLeftMenuComponent,
    LiteHeaderComponent,
    LiteStoryContainerComponent,
    AnalyticsDashboardComponent,
    CustomPipe,
    PhotoGalleryComponent,
    VideoCmsComponent,
    VideoCmslistingComponent,
    AllVideoCmsListingComponent,
    MicrositeComponent,
    MicrositeListingComponent,
    MicrositeContainerComponent,
    NotificationCenterPageComponent,
    TextareaAutoresizeDirective,
    PageInlineComponent,
    OgImageComponent,
    BrunchPreviewComponent,
    BrunchElementComponent,
    NewSecondarySectionComponent,
    NewSecondarySectionFormComponent,
    SaranyuVideoListComponent,
  ],
  imports: [
    CarouselModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    SocialLoginModule,
    CKEditorModule,
    QuillModule,
    Daterangepicker,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    // DragulaModule,
    EmbedVideo.forRoot(),
    // AngularCropperjsModule,
    BrowserAnimationsModule,
    SnotifyModule,
    NgSelectModule,
    // InfiniteScrollModule,
    // PdfJsViewerModule,
    // AngularMultiSelectModule,
    ColorPickerModule,
    SharedModule,
    MatProgressBarModule,
    MatCardModule,
    MatButtonModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(firebase),
  ],
  providers: [
    StoryContainerService,
    AuthenticationService,
    AuthGuard,
    UserAuthGuard,
    HasRoleGuard,
    CanDeactivateGuard,
    VideoDeactivateGuard,
    Title,
    RestDataService,
    SharedDataService,
    CommonUtilityService,
    HttpCacheService,
    TranslateService,
    LocalstorageService,
    GoogleAnalyticsService,
    SpeechService,
    AnalyticsRoleGuard,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    },
    Config,
    {
      provide: APP_INITIALIZER,
      useFactory: configProviderFactory,
      deps: [Config],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    },
    KeyboardShortcuts,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
    SnotifyService,
    {provide: SAVER, useFactory: getSaver},
    MessagingService,
    AsyncPipe
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}


// platformBrowserDynamic().bootstrapModule(AppModule);
